export const TOKEN_KEY = 'realcity_admin_token';
export const REFRESH_KEY = 'realcity_admin_refresh';
export const ADMIN_KEY = 'realcity_admin_user';

export const getToken = () => localStorage.getItem(TOKEN_KEY) || '';
export const getRefreshToken = () => localStorage.getItem(REFRESH_KEY) || '';
export const setAuth = ({ token, refreshToken, admin }) => {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  if (refreshToken) localStorage.setItem(REFRESH_KEY, refreshToken);
  localStorage.setItem(ADMIN_KEY, JSON.stringify(admin || null));
};
export const clearAuth = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(REFRESH_KEY);
  localStorage.removeItem(ADMIN_KEY);
};
export const getAdmin = () => {
  try { return JSON.parse(localStorage.getItem(ADMIN_KEY) || 'null'); } catch { return null; }
};
export const hasRole = (roles=[]) => {
  const admin = getAdmin();
  return !!admin && roles.includes(admin.role);
};
